module.exports = __webpack_public_path__ + "f7ddb53d8d9f735c383b6d5ab4f5ebb1.jpg";